// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveySaveQuestionResultModelResponse {
    static getAttributeTypeMap() {
        return SurveySaveQuestionResultModelResponse.attributeTypeMap;
    }
}
SurveySaveQuestionResultModelResponse.discriminator = undefined;
SurveySaveQuestionResultModelResponse.additionalProperties = false;
SurveySaveQuestionResultModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "SurveySaveQuestionResultResponseModel"
    },
];
//# sourceMappingURL=surveySaveQuestionResultModelResponse.js.map